<template>
  <div>
    <VueFileAgent
      ref="fileAgent"
      :multiple="true"
      :deletable="true"
      :meta="true"
      :accept="'video/*'"
      :maxSize="maxSize"
      :maxFiles="1"
      :helpText="selectText"
      :readonly="isReadOnly"
      :errorText="{
        type:errorMessage,
        size: errorSize,
      }"
      :thumbnailSize="120"
      :theme="'list'"
      v-model="fileRecords"
      @select="filesSelected($event)"
      @beforedelete="onBeforeDelete($event)"
      @delete="onDelete($event)"
    ></VueFileAgent>
    <k-progress type="line" :percent="percentCnt"></k-progress>

    <p class="txt_input">
      * 동영상 파일은 400MB까지 첨부가능합니다.
    </p>
    <span>{{ videoUploadRes.resText }}</span>

    <!-- 썸네일 목록 -->
    <div v-if="!hidethumbselection && thumFileList != null && thumFileList.length > 0" >
      <div class="pd_t10 tit">
        <b>대표 이미지를 선택해 주세요.</b>
<!--        pick_thum_uid = {{ pick_thum_uid }}-->
      </div>
      <div v-for="(titem) in thumFileList" style="display: inline-block; cursor: pointer;" >
        <p class="check_row mg_t5 mg_b5">
          <label class="flex mx-5 my-5 radio_box" v-bind:for="titem.cmm_uid">
            <input type="radio" :value="titem.cmm_uid" :id="titem.cmm_uid" v-model="pick_thum_uid">
            <span class="r_on"></span>
            <span class="common_label" style="padding: 0 8px"
                  v-bind:for="titem.cmm_uid"><img
              v-bind:src="titem.file_path"
              width="210px"
              height="370px"
              @click="onClickThum(titem.cmm_uid)"
            ></span>

          </label>
<!--
          <input type="radio" v-model="pick_thum_uid" :value="titem.cmm_uid" :id="titem.cmm_uid" hidden="hidden">
          <label for="price1" tabindex="600" @keydown.enter="$('#price1').trigger('click');">
            <img
              v-bind:src="titem.file_path"
              width="210px"
              height="370px"
              @click="onClickThum(titem.cmm_uid)"
            >
          </label>-->
        </p>
<!--        :style="titem.cmm_uid === pick_thum_uid ? 'border: 10px solid red;' : ''"-->
      </div>
    </div>

    <div v-if="!hidethumbselection" class="pd_t10">
      대표 이미지 직접 업로드
      <VueFileAgent
        ref="imgFileAgent"
        :multiple="true"
        :deletable="true"
        :meta="true"
        :accept="'image/*'"
        :maxSize="'2048MB'"
        :maxFiles="1"
        helpText="이미지 파일을 선택해 주세요."
        :errorText="{
          type: imgErrorMessage,
          size: imgErrorSize,
        }"
        :thumbnailSize="120"
        :theme="'list'"
        v-model="imgFileRecords"
        @select="filesImgSelected($event)"
        @beforedelete="onBeforeImgDelete($event)"
      ></VueFileAgent>
    </div>

  </div>
</template>
<script>
import Axios from 'axios'

export default {
  // ...
  data: function () {
    const maxSize = this.maxsize || '400MB' // maxsize 지정하지 않을경우 기본값
    return {
      fileRecords: [],
      detail: {},
      selectText: "파일을 선택해주세요",
      errorMessage: "이 형식은 비디오형식이 아닙니다.",
      errorSize: `사이즈가 ${maxSize}}가 넘습니다. (code=dXQXpC86ks7)`,
      cnt: 0,
      isReadOnly: false,
      detailOption: '',
      option: '',
      percentCnt: 0,
      maxSize,
      thumFileList: [],
      pick_thum_uid: 0,
      videoUploadRes: {}, // TODO CHECK :: 개선
      // =================================================================
      imgFileRecords: [],
      imgErrorMessage: "이 형식은 이미지형식이 아닙니다.",
      imgErrorSize: "사이즈가 2GB가 넘습니다.",
      imgCnt: 0
    };
  },
  props: ['listvideofile','maxsize', 'listvdthumfile', 'listimgfile', 'hidethumbselection'],
  mounted: function () {
    // this.getThumFileList()
  },
  watch: {
    listvideofile: function (newVal, oldVal) {
      let vm = this;
      if (newVal.length > 0) {
        for (let i = 0; i < newVal.length; i++) {
          this.fileRecords.push(this.setFileRemindFromDB(newVal[i]));
          vm.cnt++;
        }
      }
    },
    detailOption: function (newVal) {
      let vm = this;
      vm.option = newVal;
    },
    listvdthumfile: function (newVal) {
      let vm = this;
      if (newVal != null && newVal.length > 0) {
        vm.thumFileList = newVal

        // 대표 이미지로 지정된 것
        newVal.map(item => {
          if (item.SEL_YN === 'Y') vm.pick_thum_uid = item.cmm_uid
        })
      }
    },
    listimgfile: function (newVal, oldVal) {
      let vm = this;
      if (newVal.length > 0) {
        for (let i = 0; i < newVal.length; i++) {
          this.imgFileRecords.push(this.setImgFileRemindFromDB(newVal[i]));
          vm.imgCnt++;
        }
      }
    }
  },
  methods: {
    selectDurTime: function (evt) {
      let vm = this;
      vm.detailOption = evt;

    },
    filesSelected(evt) {

      let vm = this;

      if (evt.length == 0) {

      } else {

        for (let i = 0; i < evt.length; i++) {
          if (evt[i].file.type.indexOf('video') > -1) {
            vm.cnt++;
            vm.getUploadFiles(evt[i], vm.cnt);
          } else {
            continue;
          }
        }
      }

    },
    onBeforeDelete(fileRecord) {
      let vm = this;

      if (confirm('삭제하시겠습니까?')) {
        if (fileRecord.file == null) {
          let _inner = $("#fileKey").val();
          let _key = $("#fileKey").val();
          for (let i = 0; i < this.fileRecords.length; i++) {
            if (this.fileRecords[i].filePath === fileRecord.filePath) {
              let _path = fileRecord.filePath.split("/");
              let _cnt = i + 1;
              vm.getDelete(_cnt, _path[3], "new", fileRecord.fileKey);
            }
          }
        } else {
          if (fileRecord.file.type.indexOf('video') > -1) {
            for (let i = 0; i < this.fileRecords.length; i++) {
              if (this.fileRecords[i].file.name === fileRecord.file.name) {
                let _cnt = i + 1;
                vm.getDelete(_cnt, fileRecord.file.name, "org");
              }
            }
          }
        }
        this.$refs.fileAgent.deleteFileRecord(fileRecord);
        vm.$parent.videoRes = {}; // 하단 문구 초기화
      }
    },
    getDelete(_cnt, _name, type, fileKey) {

      let vm = this;
      let _form = new FormData();
      let _inner = (fileKey != null) ? fileKey : $("#fileKey").val();
      let _key = $("#fileKey").val();
      let usrKey = $("#usrKey").val();
      _form.append('paramUid', usrKey);
      _form.append('paramText', _name);
      _form.append('resultData', _cnt);
      _form.append('defaultView', _inner);
      _form.append('statusCode', type);

      Axios.post("/api/video/delete", _form, {
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(function (response) {
        vm.cnt--;
        // 영상 삭제 시, 기존 썸네일 목록 삭제 + 남은 이미지로 자동 선택
        const userItem = vm.thumFileList.find((item) => item.CMM_RPRSNTTV === 'user');
        if (userItem == null) { // 사용자가 올린 이미지 없음. 그럼 초기화
          vm.pick_thum_uid = 0
          vm.thumFileList = []
        } else if (userItem.cmm_uid === vm.pick_thum_uid) { // 사용자가 올린 이미지가 있는데 그 이미지를 대표로 선택한 경우
          vm.thumFileList = vm.thumFileList.filter((item) => item.CMM_RPRSNTTV !== 'auto'); // 사용자가 올린 이미지만 남기고 나머지 삭제
        } else { // 사용자가 올린 이미지가 있지만 대표로 선택하지 않은 경우
          vm.pick_thum_uid = userItem.cmm_uid // 사용자가 올린 이미지로 자동 선택
          vm.thumFileList = vm.thumFileList.filter((item) => item.CMM_RPRSNTTV !== 'auto'); // 사용자가 올린 이미지만 남기고 나머지 삭제
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    setFileRemindFromFile(_data, time) {
      return {
        name: _data.file.name,
        sizeText: _data.sizeText,
        size: _data.size,
        type: _data.type,
        ext: _data.ext,
        width: _data.dimensions.width,
        height: _data.dimensions.height,
        color: _data.color,
        durTime: (time == null) ? null : time.durTime,
        setTime: (time == null) ? null : time.setTime,

      };
    },
    setFileRemindFromDB(_data) {
      return {
        name: _data.file_org_name,
        sizeText: _data.sizeText,
        size: _data.size,
        type: _data.filetype,
        ext: _data.fileExt,
        filePath: '/video/' + _data.file_new_name.substring(0, 8) + "/" + _data.file_new_name,
        //   url: "http://localhost:8080/video/" + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
        url: "/video/" + _data.file_new_name.substring(0, 8) + "/" + _data.file_new_name,
        fileKey: _data.cmm_sprt,
        //urlResized: _data.imgBase64,
        lastModified: 1583992794341
      };
    },
    getUploadFiles(evt, cnt) {
      let vm = this;
      let _inner = $("#fileKey").val();
      let _key = $("#fileKey").val();
      let _form = new FormData();
      let _detailOption = (vm.$parent.detailOption == null || vm.$parent.detailOption == undefined) ? null : vm.$parent.detailOption;
      let _data = vm.setFileRemindFromFile(evt, _detailOption);
      let _param = _data;

      _form.append('uploadFiles', evt.file);
      _form.append('paramText', _key);
      _form.append('resultData', vm.cnt);
      _form.append('defaultView', _inner);
      _form.append('paramOption', JSON.stringify(_param));

      if (typeof (vm.$parent.videoRes) != undefined) {
        vm.$parent.videoRes = {resValue: "ready", resText: "업로드 중..."};
        vm.videoUploadRes = {resValue: "ready", resText: "업로드 중..."}; // TODO CHECK :: 개선
      }

      for (var i = 0; i < this.fileRecords.length; i++) {
        console.log(vm.fileRecords[i].error);

        if (vm.fileRecords[i].error.size) {
          vm.$parent.videoRes = {resValue: "fail"};
          vm.percentCnt = 0;
          return;
        }
        if (vm.fileRecords[i].error.type) {
          vm.$parent.videoRes = {resValue: "fail"};
          vm.percentCnt = 0;
          return;
        }
      }

      const config = {
        headers: {'Content-Type': 'multipart/form-data'},
        onUploadProgress: (progressEvent) => {
          vm.percentCnt = Math.round((progressEvent.loaded * 95) / progressEvent.total);
        }
      }

      Axios.post("/api/video/upload_create_multi_thum", _form, config).then(function (response) {
        if (typeof (vm.$parent.videoRes) != undefined) {
          if (response.data.result == null || response.data.result == "-999") {
            vm.$parent.videoRes = {resValue: "fail", resText: "업로드 실패 - 지원하지 않는 형식입니다. avi 확장자로 변환한 뒤 다시 시도해주세요."};
            vm.videoUploadRes = {resValue: "fail", resText: "업로드 실패 - 지원하지 않는 형식입니다. avi 확장자로 변환한 뒤 다시 시도해주세요."}; // TODO CHECK :: 개선
            vm.percentCnt = 0;
          } else {
            console.log("response.data.result", response.data.result);
            //시작시간 오류
            if (response.data.result == "err_durTime") {
              vm.$parent.videoRes = {resValue: "fail", resText: "업로드 실패 - 영상의 총 길이보다 시작시간이 큽니다."};
              vm.videoUploadRes = {resValue: "fail", resText: "업로드 실패 - 영상의 총 길이보다 시작시간이 큽니다."}; // TODO CHECK :: 개선
              vm.percentCnt = 0;
            } else {
              console.log("영상 업로드 성공!!!!!!!")
              vm.$parent.videoRes = {resValue: "succ", resText: "업로드 성공"};
              vm.videoUploadRes = {resValue: "succ", resText: "업로드 성공"}; // TODO CHECK :: 개선
              vm.percentCnt = 100;
              vm.getThumFileList()
              // 썸네일 자동 생성
              // Axios.post("/api/video/create_thum", _form, config).then(function (res) {
              //   console.log("썸네일 자동생성 결과")
              //   console.log(res)
              // })
            }
          }

          //vm.$parent.videoRes = (response.data.result == null) ? {resValue:"fail",resText:"업로드 실패"} : {resValue:"succ",resText:"업로드 성공"};
          //vm.percentCnt = (response.data.result == null) ? 0 : 100;
        }
      }).catch(function (ex) {
        console.log(ex);
        vm.$parent.videoRes = {resValue: "fail", resText: "업로드 실패"}
        vm.videoUploadRes = {resValue: "fail", resText: "업로드 실패"} // TODO CHECK :: 개선
        vm.percentCnt = 0;
      });
    },
    onDelete(evt) {
    },
    getThumFileList() { // 썸네일 목록 조회
      let vm = this
      let param = { paramText: $("#fileKey").val() }
      // let param = { paramText: 'FILE_000000000157070' }
      // let param = { paramText: 'HBSUIDNV_00000000000000004420' }
      Axios.post("/api/video/thum_list", param).then(function (response) {
        // 썸네일 목록이 비어있지 않은 경우 ( 사용자가 이미지를 먼저 올렸거나.. 수정모드에서 영상을 삭제하고 사용자가 올린 이미지만 남은 경우 )
        if (vm.thumFileList != null && vm.thumFileList.length > 0) {
          vm.thumFileList.push(...response.data.thumFileList) // 기존 썸네일 목록에 추가
        } else {
          vm.thumFileList = response.data.thumFileList
          // 제일 첫번째 썸네일을 자동 선택
          if (response.data.thumFileList != null && response.data.thumFileList.length > 0) {
            vm.pick_thum_uid = response.data.thumFileList[0].cmm_uid
          }
        }
      })
    },
    onClickThum(uid) {
      let vm = this
      vm.pick_thum_uid = uid
    },
    // =================================================================
    // 이미지 업로더 ======================================================
    // =================================================================
    filesImgSelected(evt) {
      let vm = this;
      if (evt.length == 0) {

      } else {
        for (let i = 0; i < evt.length; i++) {
          if (evt[i].file.type.indexOf('image') > -1) {
            vm.imgCnt++;
            vm.getImgUploadFiles(evt[i], vm.imgCnt);
          } else {
            continue;
          }
        }
      }
    },
    onBeforeImgDelete(fileRecord) {
      let vm = this;
      if (confirm('삭제하시겠습니까?')) {
        if (fileRecord.file == null) {
          let _inner = $("#fileKey").val();
          let _key = $("#fileKey").val();
          for (let i = 0; i < this.imgFileRecords.length; i++) {
            if (this.imgFileRecords[i].filePath === fileRecord.filePath) {
              let _path = fileRecord.filePath.split("/");
              let _cnt = i + 1;
              vm.getImgDelete(_cnt, _path[3], "new", fileRecord.fileKey);
            }
          }
        } else {
          if (fileRecord.file.type.indexOf('image') > -1) {
            for (let i = 0; i < this.imgFileRecords.length; i++) {
              if (this.imgFileRecords[i].file.name === fileRecord.file.name) {
                let _cnt = i + 1;
                vm.getImgDelete(_cnt, fileRecord.file.name, "org", fileRecord.fileKey);

              }
            }
          }
        }
        this.$refs.imgFileAgent.deleteFileRecord(fileRecord);
      }
    },
    getImgDelete(_cnt, _name, type, fileKey) {
      let vm = this;
      let _form = new FormData();
      // let _inner = $("#fileKey").val();
      let _inner = (fileKey != null) ? fileKey : $("#fileKey").val();
      let _key = $("#fileKey").val();
      let usrKey = $("#usrKey").val();
      _form.append('paramUid', usrKey);
      _form.append('paramText', _name);
      _form.append('resultData', _cnt);
      _form.append('defaultView', _inner);
      _form.append('statusCode', type);

      Axios.post("/api/vdthumimg/delete", _form, {
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(function (response) {
        vm.imgCnt--;
        const delItem = vm.thumFileList.find((item) => item.CMM_RPRSNTTV === 'user');
        if (delItem != null && delItem.cmm_uid === vm.pick_thum_uid) { // pick 이미지였다면
          if (vm.thumFileList != null && vm.thumFileList.length > 0) { // 썸네일 목록있으면 첫번째 이미지로 자동선택
            vm.pick_thum_uid = vm.thumFileList[0].cmm_uid
          } else {
            vm.pick_thum_uid = 0 // 목록 없으면 그냥 비워주기
          }
        }

        vm.thumFileList = vm.thumFileList.filter((item) => item.CMM_RPRSNTTV !== 'user'); // 대표 이미지 목록에서 해당 이미지 삭제
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    setImgFileRemindFromFile(_data) {
      return {
        name: _data.file.name,
        sizeText: _data.sizeText,
        size: _data.size,
        type: _data.type,
        ext: _data.ext,
        width: _data.dimensions.width,
        height: _data.dimensions.height,
        color: _data.color
      };

    },
    setImgFileRemindFromDB(_data) {
      return {
        name: _data.file_org_name,
        sizeText: _data.sizeText,
        size: _data.size,
        type: _data.filetype,
        ext: _data.fileExt,
        filePath: '/video/' + _data.file_new_name.substring(0, 8) + "/" + _data.file_new_name,
        // url: "http://localhost:8080/img/" + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
        url: "/video/" + _data.file_new_name.substring(0, 8) + "/" + _data.file_new_name,
        fileKey: _data.cmm_sprt,
        //urlResized: _data.imgBase64,
        lastModified: 1583992794341
      };
    },
    getImgUploadFiles(evt, cnt) {
      let vm = this;
      let _inner = $("#fileKey").val();
      let _key = $("#fileKey").val();
      let _form = new FormData();
      let _data = vm.setImgFileRemindFromFile(evt);

      let _param = _data;

      _form.append('uploadFiles', evt.file);
      _form.append('paramText', _key);
      _form.append('resultData', vm.imgCnt);
      _form.append('defaultView', _inner);
      _form.append('paramOption', JSON.stringify(_param));

      Axios.post("/api/vdthumimg/upload", _form, {headers: {'Content-Type': 'multipart/form-data'}}).then(function (response) {
        // 대표 이미지 목록에 해당 이미지 추가
        vm.thumFileList.push({
          cmm_uid: response.data.res_file_seq,
          file_path: '/video/' + response.data.result.substring(0, 8) + "/" + response.data.result,
          SEL_YN: 'N',
          CMM_RPRSNTTV: 'user',
        })
      }).catch(function (ex) {
        console.log(ex);
      });
    },
  }
}
</script>
